import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
} from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon } from 'assets/icons';
import ModalCreate from './modal-create';
import { ServiceService } from 'services';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
};

class AdminServices extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['Servicio a configurar', 'Precio $', 'Acciones'],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    visible: false,
    item: null,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Configuraciones',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await ServiceService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
    });
    this.setState({
      data: res.services.rows,
      last_page: res.services.count,
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  add = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  render() {
    const { visible } = this.state;

    let className = '';

    // @ts-ignore
    switch (this.state.item?.id) {
      case Constants.SERVICES.PREPARATION:
        className = 'modal-new';
        break;
      case Constants.SERVICES.REVISION:
        className = 'modal-new';
        break;
      case Constants.SERVICES.CHAT:
        className = 'modal-chat';
        break;
      default:
        className = '';
    }

    return (
      <div id="admin-services">
        <Modal
          // @ts-ignore
          className={`modal-create-service ${className}`}
          visible={visible}
          // @ts-ignore
          title={this.state.item?.name}
          onClose={() => this.onClose()}
        >
          <ModalCreate item={this.state.item} onClose={() => this.onClose()} />
        </Modal>

        <div className="row row-filter">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-5">
                <Input
                  value={this.state.form.search}
                  name="search"
                  placeholder="Nombre del servicio"
                  label="Buscar"
                  className="input-table"
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className="col-md-1">
                {this.state.form != INITIAL_STATE && (
                  <button
                    className="btn btn-clean"
                    onClick={() => this.reset()}
                  >
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title="Servicios a configurar"
          data={this.state.data.length}
          header={this.state.header}
          rightAlign={[2]}
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{i.name}</td>
                <td>
                  {i.price &&
                  (i.id === Constants.SERVICES.SIGN ||
                    i.id === Constants.SERVICES.FORMALITIES)
                    ? Globals.formatMiles(i.price)
                    : '-'}
                </td>
                <td className="text-right">
                  {checkPermission(Constants.MODULES.SERVICES, 'write') && (
                    <Tooltip title="Editar">
                      <a
                        className="link-icon"
                        href="#"
                        onClick={(e: any) => this.edit(e, i)}
                      >
                        <img src={EditIcon} />
                      </a>
                    </Tooltip>
                  )}
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminServices);
